import { useMemo } from 'react';
import PropTypes from 'prop-types';
import Layout from '../../components/layouts/freshest/FreshestLayout';
import PackageEfficacyPageFragment from '../../components/reports/package-efficacy/PackageEfficacy';
import packageFaqs from '@mdc/ui/src/detection-overview/faqs.data';
import OutbreakReportPageFragment from '../../components/reports/outbreak/Outbreak';
import Sanitization from '../../components/reports/sanitization/Sanitization';
import outbreakFaqs from '@mdc/ui/src/outbreak/faqs.data';
import { graphql } from 'gatsby';
import MarketShareV2 from '../../components/reports/market-share/MarketShareV2';

const ReportsPage = ({ data, pageContext }) => {
    const currentPage = pageContext.currentPage;

    const PageFragment = useMemo(() => {
        switch (currentPage) {
            case 'package-efficacy':
                return <PackageEfficacyPageFragment faqs={packageFaqs} engineImages={data}/>;
            case 'outbreak':
                return <OutbreakReportPageFragment faqs={outbreakFaqs}/>;
            case 'sanitization':
                return <Sanitization pageName={currentPage}/>;
            case 'anti-malware-market-share':
                return <MarketShareV2/>;
        }
    }, [currentPage, data]);
    return (
        <Layout pageTitle="Reports" hasAnnouncementBanner={false}>
            {PageFragment}
        </Layout>
    );
};

ReportsPage.propTypes = {
    pageContext: PropTypes.object.isRequired,
    data: PropTypes.object
};

export default ReportsPage;

export const enginePackageImages = graphql`
query enginePackageImages {
    aegislab: imageSharp(resize: {originalName: {eq: "aegis-lab.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    ahnlab: imageSharp(resize: {originalName: {eq: "ahn-lab.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    antiy: imageSharp(resize: {originalName: {eq: "antiy.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    avira: imageSharp(resize: {originalName: {eq: "avira.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    bitdefender: imageSharp(resize: {originalName: {eq: "bitdefender.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    clamav: imageSharp(resize: {originalName: {eq: "clamav.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    comodolicensing: imageSharp(resize: {originalName: {eq: "comodo-licensing.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    crowdstrikefalconml: imageSharp(resize: {originalName: {eq: "crowdstrikefalconml.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    cyren: imageSharp(resize: {originalName: {eq: "cyren.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    emsisoft: imageSharp(resize: {originalName: {eq: "emsisoft.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    eset: imageSharp(resize: {originalName: {eq: "eset.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    filseclab: imageSharp(resize: {originalName: {eq: "filseclab.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    huorong: imageSharp(resize: {originalName: {eq: "huorong.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    ikarus: imageSharp(resize: {originalName: {eq: "ikarus.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    kaspersky: imageSharp(resize: {originalName: {eq: "kaspersky.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    k7: imageSharp(resize: {originalName: {eq: "k7.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    lavasoft: imageSharp(resize: {originalName: {eq: "lavasoft.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    mcafee: imageSharp(resize: {originalName: {eq: "mcafee.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    microsoftsecurityessentials: imageSharp(resize: {originalName: {eq: "microsoft.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    windowsdefender: imageSharp(resize: {originalName: {eq: "windowsdefender.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    nanoav: imageSharp(resize: {originalName: {eq: "nanoav.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    netgate: imageSharp(resize: {originalName: {eq: "netgate.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    sophos: imageSharp(resize: {originalName: {eq: "sophos.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    symantec: imageSharp(resize: {originalName: {eq: "symantec.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    systweak: imageSharp(resize: {originalName: {eq: "systweak.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    quickheal: imageSharp(resize: {originalName: {eq: "quickheal.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    rocketcyber: imageSharp(resize: {originalName: {eq: "rocketcyber.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    tachyon: imageSharp(resize: {originalName: {eq: "tachyon.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    trendmicro: imageSharp(resize: {originalName: {eq: "trendmicro.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    trendmicrohousecall: imageSharp(resize: {originalName: {eq: "trendmicrohousecall.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    vir_itexplorer: imageSharp(resize: {originalName: {eq: "viritexplorer.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    virit: imageSharp(resize: {originalName: {eq: "virit.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    vir_itml: imageSharp(resize: {originalName: {eq: "virit.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    virusblokada: imageSharp(resize: {originalName: {eq: "virusblokada.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    xviruspersonalguard: imageSharp(resize: {originalName: {eq: "xviruspersonalguard.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    zillya: imageSharp(resize: {originalName: {eq: "zillya.png"}}) {
        fluid(quality: 100, maxWidth: 100) {
            ...GatsbyImageSharpFluid
        }
    }
    opswatLogo: file(relativePath: {eq: "opswat.svg"}) {
        publicURL
    }
  }
`;
